import "./style.css"

import navigation from "./js/navigation.js"
import header from "./js/header.js"
import contact from "./js/contact.js"
import effects from "./js/effects.js"
import modal from "./js/modal.js"
import slider from "./js/slider.js"
import estateOverview from "./js/estates.js"
import offices from "./js/offices.js"
import services from "./js/services.js"
import share from "./js/share.js"
import compare from "./js/compare.js"
import tags from "./js/tags.js"
import form from "./js/form.js"
import popup from "./js/popup.js"
import estate from "./js/estate.js"
import gallery from "./js/gallery.js"
import video from "./js/video.js"

navigation()
header()
contact()
effects()
modal()
slider()
estateOverview()
offices()
services()
share()
compare()
tags()
form()
popup()
estate()
gallery()
video()
